// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// defineApp
export { defineApp } from './core/defineApp'
export type { RuntimeConfig } from './core/defineApp'
// plugins
export { Access, useAccess, useAccessMarkedRoutes } from '/app/src/.umi-production/plugin-access';
export { useAntdConfig, useAntdConfigSetter } from '/app/src/.umi-production/plugin-antd';
export { Provider, useModel } from '/app/src/.umi-production/plugin-model';
export { useRequest, UseRequestProvider, request, getRequestInstance } from '/app/src/.umi-production/plugin-request';
// plugins types.d.ts
export * from '/app/src/.umi-production/plugin-access/types.d';
export * from '/app/src/.umi-production/plugin-antd/types.d';
export * from '/app/src/.umi-production/plugin-layout/types.d';
export * from '/app/src/.umi-production/plugin-request/types.d';
// @umijs/renderer-*
export { createBrowserHistory, createHashHistory, createMemoryHistory, Helmet, HelmetProvider, createSearchParams, generatePath, matchPath, matchRoutes, Navigate, NavLink, Outlet, resolvePath, useLocation, useMatch, useNavigate, useOutlet, useOutletContext, useParams, useResolvedPath, useRoutes, useSearchParams, useAppData, useClientLoaderData, useLoaderData, useRouteProps, useSelectedRoutes, useServerLoaderData, renderClient, __getRoot, Link, useRouteData, __useFetcher, withRouter } from '/app/node_modules/.pnpm/@umijs+renderer-react@4.6.29_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@umijs/renderer-react';
export type { History, ClientLoader } from '/app/node_modules/.pnpm/@umijs+renderer-react@4.6.29_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@umijs/renderer-react'
// umi/client/client/plugin
export { ApplyPluginsType, PluginManager } from '/app/node_modules/.pnpm/umi@4.6.29_@babel+core@7.29.0_@types+node@25.3.1_@types+react@18.3.28_eslint@8.35.0_jes_731ace154587c9ae28124ba71bcb44bf/node_modules/umi/client/client/plugin.js';
export { history, createHistory } from './core/history';
export { terminal } from './core/terminal';
// react ssr
export const useServerInsertedHTML: Function = () => {};
